import React, { useEffect, useState } from "react";
import "./Styles/Dashboard.css";
import DashboardSidebar from "./Components/Sidebar/DashboardSidebar";
import DashHero from "./Components/Hero/DashHero";
import Contact from "./Components/content/Contact";
import { useNavigate } from "react-router-dom";

const DashBoard = () => {
  const [active, setActive] = useState(1);
  const navigate = useNavigate();
  useEffect(() => {
    if (!localStorage.getItem("x_token")) {
      navigate("/admin/login");
    }
  }, []);
  return (
    <div className="DashBoard">
      <DashboardSidebar setActive={setActive} />
      {active === 1 && <DashHero />}
      {active === 2 && <Contact />}
    </div>
  );
};

export default DashBoard;
